import React, { useState, useEffect, useRef } from 'react';
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actionspackStatusList from './_redux/PacksStatusActions';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';

const DropdownPackStatus = ({ select = undefined, selected, setSelected }) => {
    const [change, setChange] = useState(false);
    const toast = useRef(null);
    const dispatch = useDispatch();
    const { packStatusList, listLoading, error } = useSelector(
        state => state.packstatus,
        shallowEqual
    );
    useEffect(() => {
        if (!packStatusList && !error) {
            dispatch(actionspackStatusList.fetchPackStatusList({}));
        };
    }, [packStatusList, error, dispatch]);
    useEffect(() => {
        if (error) {
            toast.current.show({ severity: 'error', summary: 'Status List', detail: error });
        };
    }, [error]);
    return (
        <div>
            <Toast ref={toast} position="bottom-right" />
            {select && !change ?
                <div className="p-inputgroup">
                    <InputText value={select} disabled />
                    <Button icon="pi pi-pencil" style={{ color: 'white' }} className="p-button-warning" onClick={() => setChange(true)} type="button" />
                </div>
                :
                !packStatusList && listLoading ?
                    <div className="p-d-flex p-jc-center">
                        <ProgressSpinner style={{ width: '30px', height: '30px' }} strokeWidth="8" animationDuration="3s" />
                    </div>
                    :
                    <div className="p-d-flex p-flex-row">
                        <Dropdown className={select ? "p-col-10" : "p-col-12"} optionLabel="ds_status_name" optionValue="id_status" value={selected}
                            options={packStatusList}
                            onChange={(e) => setSelected(e.value)}
                            placeholder="Select a Status"
                        />
                        {select &&
                            <Button icon="pi pi-times" className="p-button-danger"
                                onClick={() => {
                                    setSelected(0);
                                    setChange(false);
                                }}
                                type="button"
                                tooltip="Cancel"
                            />
                        }
                    </div>
            }
        </div>
    )
}

export default DropdownPackStatus
